export default __webpack_public_path__ + "static/media/MySQL-WindowsTaskScheduler-Result09.4fd1cb3d.png";